export enum ReinsurancesTypeEnum {
  CLIENT_SERVICE = 'CLIENT_SERVICE',
  EXTENDED_WARRANTY = 'EXTENDED_WARRANTY',
  REPAIRABILITY = 'REPAIRABILITY',
  WARRANTY = 'WARRANTY'
}
